<template>
    <div class="consultation__conten">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div style="margin-top: 60px">
            <div class="wrapper__w cons_case__det" :style="{'background':'url('+icon_2+')', 'background-size': '100% 100%', 'background-repeat': 'no-repeat'}">
                <div class="cons_case__base relative  animate__animated  animate__fadeIn">
                    <div class="title"><span>{{baseInfo.name}}</span></div>
                    <div class="des">{{baseInfo.time}}</div>
                </div>
            </div>
        </div>
        <div class="wrapper__wpd animate__animated  animate__fadeI" style="padding-top: 50px" v-html="baseInfo.content"></div>
        <Footer></Footer>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/cos01.png'
    import icon_2 from '@/assets/img/cosn2.png'
    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,icon_2,
                baseInfo: {}
            }
        },
        components: {
            NavSecond, Footer
        },
        methods: {
            /**
             * @description详情
             * */
            getDetail() {
                this.$xhr(this.$api.articleDetail, {id: this.$route.query.id}).then(res => {
                    this.baseInfo = res
                })
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.getDetail()
            })
        },
    }
</script>
<style  lang="scss" scoped>
    .consultation__conten{
        .cons_case__det{
            height: 230px;
            .cons_case__base{
                width: 80%;
                margin: 0 auto;
                padding-top: 60px;
                .title{
                    position: relative;
                    height: auto;
                    line-height: unset;
                    text-align: center;
                    font-size: 32px;
                    font-weight: bold;
                    span::after{
                        content: '';
                        display: block;
                        position: absolute;
                        left: 50%;
                        margin-left: -16px;
                        bottom: -70px;
                        width: 32px;
                        height: 4px;
                        background: #F55E1B;
                    }
                }
                .des{
                    margin-top: 30px;
                    text-align: center;
                    font-size: 16px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 24px;
                }

            }

        }
    }

</style>
